import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// Styles
import styles from './yourTeamSection.module.scss';

const YourTeamSection = ({ job }) => {
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  const hasTeamSection =
    job.extra_info?.team_desc ||
    job.extra_info?.superior_role ||
    job.extra_info?.team_size ||
    job.extra_info?.team_language;

  if (!hasTeamSection) return null;

  return (
    <section id="your-team-section" className={styles.container}>
      <h2 className={styles.heading}>
        {t(`description_page.your_team_section.title.${approach}`)}
      </h2>
      <div
        className={`html-div ${styles.content}`}
        dangerouslySetInnerHTML={{
          __html: job.extra_info?.team_desc,
        }}
      />
      <div>
        <ul className={styles.list}>
          {job.extra_info?.superior_role && (
            <li>
              {t(`description_page.your_team_section.reports_to.${approach}`)}
              <span className={styles.separator}>:</span>{' '}
              {job.extra_info?.superior_role}
            </li>
          )}
          {job.extra_info?.team_size && (
            <li>
              {t(`description_page.your_team_section.colleagues.${approach}`)}
              <span className={styles.separator}>:</span>{' '}
              {job.extra_info?.team_size}
            </li>
          )}
          {job.extra_info?.team_language && (
            <li>
              {t(
                `description_page.your_team_section.team_language.${approach}`,
              )}
              <span className={styles.separator}>:</span>{' '}
              <span className={styles.language}>
                {job.extra_info?.team_language}
              </span>
            </li>
          )}
        </ul>
      </div>
    </section>
  );
};

YourTeamSection.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
};

export default YourTeamSection;
